export default __webpack_public_path__ + "static/media/o1.250ee2c5.jpg";